import { push } from 'react-router-redux'
import type { Dispatch } from 'redux'

import type { CollectionSlug, CollectionUUID } from '@library/menu-service'

import type { MenuCollectionsState } from 'reducers/menu-collections/menuCollections'
import { getCollection } from 'selectors/menu-collections/getCollection'
import { getCollectionIdBySlug } from 'selectors/menu-collections/getCurrentCollectionId'

type CollectionIdAndSlug = { id: CollectionUUID; slug: CollectionSlug }
export type SelectCollectionCallback = (
  oldCollection: CollectionIdAndSlug | null,
  newCollection: CollectionIdAndSlug | null,
) => void

export const selectCollection =
  (id: CollectionUUID | null, callback: SelectCollectionCallback = () => {}) =>
  (dispatch: Dispatch, getState: () => MenuCollectionsState) => {
    const state = getState()

    const currentLocation = state.routing.locationBeforeTransitions
    const oldCollectionSlug = (
      Array.isArray(currentLocation.query.collection)
        ? currentLocation.query.collection[0]
        : currentLocation.query.collection
    ) as CollectionSlug | undefined
    const oldCollectionId = getCollectionIdBySlug(oldCollectionSlug || null)(state)
    const oldCollection =
      oldCollectionId !== null && oldCollectionSlug
        ? { id: oldCollectionId, slug: oldCollectionSlug }
        : null

    const query = { ...currentLocation.query }

    if (id !== null) {
      const collection = getCollection(id)(state)
      if (!collection) {
        return
      }

      if (collection.slug) {
        query.collection = collection.slug
      }
    } else {
      delete query.collection
    }

    if (query.collection !== currentLocation.query.collection) {
      dispatch(push({ ...currentLocation, query }))
    }

    const newCollectionSlug = (
      Array.isArray(query.collection) ? query.collection[0] : query.collection
    ) as CollectionSlug | undefined
    const newCollection =
      newCollectionSlug && id !== null
        ? {
            id,
            slug: newCollectionSlug,
          }
        : null

    callback(oldCollection, newCollection)
  }
